import ringbaPortalServices from '@/angularBridgeCode/ringbaPortal.servicesModule';
import { AppConfig } from '@/appConfig';
import { BuildMetaFile } from '@ringba/config/build-meta';
import { fetchDeployedJson } from '@ringba/core/appUpdates';

const BUILD_META_PATH = `/${BuildMetaFile}`;
const CHECK_INTERVAL_MS = 5 * 60 * 1000;

/**
 * Polls the deployed version until a newer build is found.
 * From then on, the next state transition becomes a full page load of its target, so the new bundles replace the old ones.
 */
ringbaPortalServices.run(['$transitions', $transitions => {
  let isNewVersionAvailable = false;

  const timer = setInterval(async () => {
    const deployed = (await fetchDeployedJson(BUILD_META_PATH))?.version;
    if (deployed && deployed !== AppConfig.version) {
      isNewVersionAvailable = true;
      clearInterval(timer);
    }
  }, CHECK_INTERVAL_MS);

  $transitions.onStart({}, transition => {
    if (!isNewVersionAvailable) {
      return undefined;
    }
    const { stateService } = transition.router;
    // A hash-only change does not reload the page, so the reload is explicit.
    window.location.href = stateService.href(transition.to(), transition.params(), { absolute: true });
    window.location.reload();
    return false;
  });
}]);
